import { useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const { processGoogleCallback } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');
        
        // Extract sede_code from query params if present
        const searchParams = new URLSearchParams(location.search);
        const sedeCode = searchParams.get('sede_code');

        if (!sessionId) {
          console.error('No session_id found');
          navigate('/login', { replace: true });
          return;
        }

        const user = await processGoogleCallback(sessionId, sedeCode);
        
        // Redirect based on role: CRM per admin/operatori, Dashboard per clienti
        if (user.role === 'super_admin' || user.role === 'admin_sede' || user.role === 'operatore') {
          navigate('/crm', { replace: true, state: { user } });
        } else {
          navigate('/dashboard', { replace: true, state: { user } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [processGoogleCallback, navigate, location.search]);

  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center">
      <div className="text-center">
        <div className="spinner mx-auto mb-4"></div>
        <p className="text-slate-400">Autenticazione in corso...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
